import React from 'react';
import PropTypes from 'prop-types';

const CustomRadio = ({ name, options, value, onChange, error, required }) => {
  return (
    <div className="flex gap-4">
      {options.map((option) => (
        <label key={option} className="flex items-center gap-2">
          <input
            id={name}
            type="radio"
            name={name}
            value={option}
            checked={value === option}
            onChange={onChange}
            required={required}
            className="form-radio h-4 w-4 text-blue-600"
          />
          <span className="text-gray-900">{option}</span>
        </label>
      ))}
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

CustomRadio.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  required: PropTypes.bool,
};

CustomRadio.defaultProps = {
  value: '',
  error: null,
  required: false,
};

export default CustomRadio;